import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import VueKonva from 'vue-konva'
import clickOutside from './directives/clickOutside'
import { setupErrorHandlers } from './utils/errorHandler'
import { loggerPlugin } from './utils/logger'
import i18n from './i18n'

const savedUser = localStorage.getItem('user')

if (savedUser) {
        const user = JSON.parse(savedUser)
        i18n.syncUserLocale(user)
        store.commit('auth/SET_USER', user)
        store.dispatch('subscription/init')
}

const app = createApp(App)

app.use(i18n)
app.directive('click-outside', clickOutside)

const toastOptions = {
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
}

app.use(store)
app.use(router)
app.use(Toast, toastOptions)
app.use(loggerPlugin)
app.use(VueKonva)

setupErrorHandlers(app)

app.mount('#app')

if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
                navigator.serviceWorker.register('/service-worker.js')
                        .then((registration) => {
                                console.log('Service Worker registered:', registration.scope);
                        })
                        .catch((error) => {
                                console.error('Service Worker registration failed:', error);
                        });
        });
}
